module.exports = __webpack_public_path__ + "img/2.8e252603.png";